import { useCallback, useEffect, useMemo, useState } from 'react';
import { getContestStats } from '../../../../auth/_requests';

export type ContestStats = {
  contestWinnersCount: number;
  rentCreditAwardedUsersCount: number;
  ticketAwardedUsersCount: number;
};

export type ContestStatsState = {
  loading: boolean;
  stats?: ContestStats;
  error?: string;
};

export const useContestStats = (opts: { token?: string; enabled: boolean }) => {
  const { token, enabled } = opts;
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<ContestStats | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  const fetchContestStats = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(undefined);
    try {
      const res = await getContestStats(token);
      setStats(res?.data);
    } catch (e) {
      console.error('Error fetching contest stats for rewards page:', e);
      setStats(undefined);
      setError(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (!enabled) return;
    fetchContestStats();
  }, [enabled, fetchContestStats]);

  return useMemo(() => ({ loading, stats, error }), [loading, stats, error]);
};

